import script from "./GoalItem.vue?vue&type=script&setup=true&lang=js"
export * from "./GoalItem.vue?vue&type=script&setup=true&lang=js"

import "./GoalItem.vue?vue&type=style&index=0&id=bf35454e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bf35454e"]])

export default __exports__